<div class="row history" *ngIf="logs.length">
  <div class="col-3 d-flex justify-content-end">
    <button
      mat-icon-button
      class="orange"
      [ngClass]="{ gray: index == 0 }"
      [disabled]="index == 0"
      (click)="moveOnHistory(move.FIRST)"
    >
      <mat-icon>first_page</mat-icon>
    </button>
    <button
      mat-icon-button
      class="orange"
      [ngClass]="{ gray: index == 0 }"
      [disabled]="index == 0"
      (click)="moveOnHistory(move.PREV)"
    >
      <mat-icon>arrow_back</mat-icon>
    </button>
  </div>
  <div
    class="col-6 d-flex flex-column align-items-center justify-content-center"
  >
    <div class="d-flex justify-content-around gap-2 align-items-center">
      <mat-slider
        *ngIf="logs.length"
        min="0"
        [max]="logs.length - 1"
        step="1"
        [thumbLabel]="false"
        [discrete]="false"
        [showTickMarks]="true"
      >
        <input
          matSliderThumb
          [(ngModel)]="index"
          #slider
          (ngModelChange)="changed($event)"
      /></mat-slider>
      <span class="ml-2 nowrap" *ngIf="index >= 0"
        >Update <span class="blue bold">{{ index + 1 }}</span> of
        <span class="blue bold">{{ logs.length }}</span></span
      >
    </div>
    <div class="d-flex full-width justify-content-between align-items-center">
      <div
        class="d-flex small flex-row align-items-center gap-1"
        *ngIf="logs.length"
      >
        <span>
          {{ index == 0 ? "Created by:" : "Updated by:" }}
          <span class="blue bold">{{ logs[index].createdByName }}</span></span
        >
        <span
          >on:
          <span class="date">{{
            logs[index].createdOn | date: "MM/dd/yyyy HH:mm:ss"
          }}</span></span
        >
      </div>
      <button
        [disabled]="index == logs.length - 1"
        mat-stroked-button
        color="primary"
        (click)="revert(logs[index])"
        class="small"
      >
        Revert to this point
      </button>
    </div>
  </div>

  <div class="col-3 d-flex justify-content-start" *ngIf="logs.length">
    <button
      mat-icon-button
      class="orange"
      [ngClass]="{
        gray: index == logs.length - 1,
      }"
      [disabled]="index == logs.length - 1"
      (click)="moveOnHistory(move.NEXT)"
    >
      <mat-icon>arrow_forward</mat-icon>
    </button>
    <button
      mat-icon-button
      class="orange"
      [ngClass]="{
        gray: index == logs.length - 1,
      }"
      [disabled]="index == logs.length - 1"
      (click)="moveOnHistory(move.LAST)"
    >
      <mat-icon>last_page</mat-icon>
    </button>
  </div>
  <button mat-icon-button (click)="logs = []" class="close-button red-bg">
    <mat-icon>close</mat-icon>
  </button>
</div>
